import AuthFooter from "./components/AuthFooter/AuthFooter";
import AuthPhoto from "./components/AuthPhoto/AuthPhoto";
import AuthTitle from "./components/AuthTitle/AuthTitle";
import "./Auth.scss";
import useMicrosoftLogin from "./logic/useMicrosoftLogin";

function Auth({ title, children, handleSubmitForm }) {
  const { loginMicrosoft } = useMicrosoftLogin();
  return (
    <div className="auth-container">
      <div className="auth-left">
        <AuthPhoto />
      </div>
      <div className="auth-right">
        <AuthTitle title={title} />
        <form className="auth-form" onSubmit={handleSubmitForm}>
          {children}
          <AuthFooter title={title} loginMicrosoft={loginMicrosoft} />
        </form>
      </div>
    </div>
  );
}
export default Auth;
